import { render, staticRenderFns } from "./lighting_design.vue?vue&type=template&id=453c5006&scoped=true"
import script from "./lighting_design.vue?vue&type=script&lang=js"
export * from "./lighting_design.vue?vue&type=script&lang=js"
import style0 from "./lighting_design.vue?vue&type=style&index=0&id=453c5006&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c5006",
  null
  
)

export default component.exports